import { useState } from 'react';

import { useMutationCreateRiskRegister } from 'api/mutations/CreateRiskRegister.mutation';

import { RiskRegisterFormTabs } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Tabs/Tabs.utils';

export const useCreateRiskRegisterFormProvider = () => {
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<RiskRegisterFormTabs>('details');

    return {
        ui: {
            state: {
                activeTab,
                showConfirmModal,
            },
            setters: {
                setActiveTab,
                setShowConfirmModal,
            },
        },
        api: {
            createRisk: {
                instance: useMutationCreateRiskRegister(),
            },
        },
    };
};
